'use strict';

angular.module('atex.dam').controller('DamMoveToFolderModalController', ['$scope', '$rootScope', 'DamFoldersService', '$q', 'DamListService',
function($scope, $rootScope, DamFoldersService, $q, DamListService) {
  
  $scope.DamFoldersService = DamFoldersService;
  $scope.showSpinner = false;
  
  //Callback
  $scope.expandNode = function(node) {
    if (node.exploring) {
      return;
    }
    node.exploring = true;
    $scope.showSpinner = true;
    DamFoldersService.expandNode(node).then(function(){
      $scope.showSpinner = false;
      delete node.exploring;
    }).then(null, function(error) {
      $scope.showSpinner = false;
      delete node.exploring;
    });
  };
  
  //Callback
  $scope.nodeSelected = function(node) {
    $scope.DamFoldersService.moveSelectedNode = node;
  };
  
  $scope.canMove = function() {
    if (!$scope.DamFoldersService.moveSelectedNode || $scope.DamFoldersService.moveSelectedNode.isRoot) {
      return false;
    }
    return true;
  };

  $scope.doMove = function() {
    var selected = angular.copy(DamListService.getSelected());
    if (selected.length > 0) {
      $scope.showSpinner = true;
      var ids = [];
      selected.forEach(function(entry) {
        ids.push(entry._data.id);
      });
      var copy = false;
      DamFoldersService.addContentToFolder(ids, $scope.DamFoldersService.moveSelectedNode, copy).then(function(){
        $scope.showSpinner = false;
        $scope.doCancel();
      }).then(null, function(error) {
        $scope.showSpinner = false;
      });
    }
  };

}]);
